export const searchProduct = () => {
  // 検索ボタン
  const searchButton = document.getElementById( 'js-search-button' );

  // テーブル
  const searchHide   = document.getElementById( 'js-hide' );
  // searchHide.style.display = 'none';

  // 登録ボタン
  const registButton  = document.querySelector( '.p-search-header__button .c-button-register' );

  // 編集ボタン
  const editButtons  = document.querySelectorAll( '.p-search-table__controller-item .edit' );

  // 削除ボタン
  const deleteButtons  = document.querySelectorAll( '.p-search-table__controller-item .delete' );

  // モーダルウィンドウ
  const modalRegist        = document.querySelector( '.js-modal-regist' );
  const modalRegistInput   = document.querySelector( '.js-modal-regist-input' );
  const modalRegistConfirm = document.querySelector( '.js-modal-regist-confirm' );
  const modalEdit          = document.querySelector( '.js-modal-edit' );
  const modalEditNext      = document.querySelector( '.js-modal-edit-next' );
  const modalDelete        = document.querySelector( '.js-modal-delete' );

  searchButton.addEventListener( 'click', () => {
    // searchHide.style.display = 'block';
  } );

  registButton.addEventListener( 'click', () => {
    modalRegist.classList.add( 'is--show' );
  } );

  editButtons.forEach( item => {
    item.addEventListener( 'click', () => {
      modalEdit.classList.add( 'is--show' );
    } );
  } );

  deleteButtons.forEach( item => {
    item.addEventListener( 'click', () => {
      modalDelete.classList.add( 'is--show' );
    } );
  } );

  modalRegist.querySelector( '.p-modal__close' ).addEventListener( 'click', () => {
    modalRegist.classList.remove( 'is--show' );
  } );
  modalRegistInput.querySelector( '.p-modal__close' ).addEventListener( 'click', () => {
    modalRegistInput.classList.remove( 'is--show' );
  } );
  modalRegistConfirm.querySelector( '.p-modal__close' ).addEventListener( 'click', () => {
    modalRegistConfirm.classList.remove( 'is--show' );
  } );
  modalEdit.querySelector( '.p-modal__close' ).addEventListener( 'click', () => {
    modalEdit.classList.remove( 'is--show' );
  } );
  modalEditNext.querySelector( '.p-modal__close' ).addEventListener( 'click', () => {
    modalEditNext.classList.remove( 'is--show' );
  } );
  modalDelete.querySelector( '.p-modal__close' ).addEventListener( 'click', () => {
    modalDelete.classList.remove( 'is--show' );
  } );

  document.querySelector( '.js-regist-next1' ).addEventListener( 'click', ( e ) => {
    modalRegist.classList.remove( 'is--show' );
    modalRegistInput.classList.add( 'is--show' );
    e.preventDefault();
  } );

  document.querySelector( '.js-regist-next2' ).addEventListener( 'click', ( e ) => {
    modalRegistInput.classList.remove( 'is--show' );
    modalRegistConfirm.classList.add( 'is--show' );
    e.preventDefault();
  } );

  document.querySelector( '.js-edit-next' ).addEventListener( 'click', ( e ) => {
    modalEdit.classList.remove( 'is--show' );
    modalEditNext.classList.add( 'is--show' );
    e.preventDefault();
  } );

  /**
   * 戻るボタン
   */
  const buttonPrevRegistInput = document.getElementById( 'js-modal-regist-input-prev' );
  buttonPrevRegistInput.addEventListener( 'click', () => {
    modalRegist.classList.add( 'is--show' );
    modalRegistInput.classList.remove( 'is--show' );
  } );

  const buttonPrevRegistConfirm = document.getElementById( 'js-modal-regist-confirm-prev' );
  buttonPrevRegistConfirm.addEventListener( 'click', () => {
    modalRegistInput.classList.add( 'is--show' );
    modalRegistConfirm.classList.remove( 'is--show' );
  } );

  const buttonPrevEdit = document.getElementById( 'js-modal-edit-prev' );
  buttonPrevEdit.addEventListener( 'click', () => {
    modalEdit.classList.remove( 'is--show' );
  } );

  const buttonPrevEditNext = document.getElementById( 'js-modal-edit-next-prev' );
  buttonPrevEditNext.addEventListener( 'click', () => {
    modalEdit.classList.add( 'is--show' );
    modalEditNext.classList.remove( 'is--show' );
  } );

  const buttonPrevDelete = document.getElementById( 'js-modal-delete-prev' );
  buttonPrevDelete.addEventListener( 'click', () => {
    modalDelete.classList.remove( 'is--show' );
  } );

  /**
   * カテゴリー設問切り替え
   */
  $( '.js-cat-hide' ).hide();
  $( 'input[data-switch-cat]' ).on( 'change', function() {
    $( '.js-cat-hide' ).hide();
    $( this ).parent().parent().next().show();
  } );
}
